/**
 * Vendor Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VendorVO { 
    id?: number;
    vendorCode?: string;
    vendorName?: string;
    vendorEmail?: string;
    vendorPhone?: string;
    vendorAddress?: string;
    description?: string;
    country?: string;
    taxNumber?: string;
    vendorType?: string;
    billingCurrency?: string;
    paymentTerm?: string;
    paymentMethod?: string;
    bankAccountName?: string;
    bankAccountNumber?: string;
    bankName?: string;
    swiftCode?: string;
    category?: string;
    riskLevel?: string;
    status?: VendorVO.StatusEnum;
    nextPossibleStatuses?: Array<VendorVO.NextPossibleStatusesEnum>;
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
}
export namespace VendorVO {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Reviewing: 'REVIEWING',
        Rejected: 'REJECTED',
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const NextPossibleStatusesEnum = {
        Draft: 'DRAFT',
        Reviewing: 'REVIEWING',
        Rejected: 'REJECTED',
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type NextPossibleStatusesEnum = typeof NextPossibleStatusesEnum[keyof typeof NextPossibleStatusesEnum];
}


